import { gql } from '@apollo/client';
import { categoryFragment, taxFragment, warehousesFragment } from '../../../../graphql/fragments';

export const GET_PAGINATED_PRODUCTS = gql`
    query GetPaginatedProducts(
      $pagination: Pagination
      $name: String
      $categories: [ID!]
      $markupSort: SortOrder
      $foodCostSort: SortOrder
    ) {
      paginatedProducts(
        pagination: $pagination, name: $name, categories: $categories, markupSort: $markupSort, foodCostSort: $foodCostSort
      ) @connection(key: "paginatedProducts", filter: ["categories", "name", "markupSort", "foodCostSort"]) {
        items {
          id
          name
          priceSell
          pohodaStockItemId
          markup
          foodCost
          tax{
            id
            rate
          }
          category {
            id
            name
            categoryId
          }
        }
        count
      }
      taxes {
        ...TaxesFragment
      }
    }
    ${taxFragment}
`;

export const GET_PRODUCT = gql`
     query GetProduct($id: String!) {
        product(id: $id) {
          id
          name
          priceSell
          priceBuy
          showInPos
          description
          priceBuyCurrency {
            currencyCode
          }
          pohodaStockItemId
          categoryId
          taxId
          toGoTaxId
          printingDevices {
            id
            name
            customName
          }
          connectedStockCard {
            id
            warehouseId
            stockCardId
            stockCard {
              id
              name
              storageUnit
              conversionUnit
              warehouses {
              	id
              	name
	            }
            }
          }
          recipe {
            id
            recipeLines {
              id
              warehouseId
              unitType
              waste
              quantity
              stockCard {
                id
                name
                storageUnit
                conversionUnit
                warehouses {           # I am worrying this is a bit too much...
                  id
                  name
                }
              }
            }
          }
        }
        categories {
            ...CategoriesFragment
            categoryId
            color
        }
        taxes {
            ...TaxesFragment
        }
        warehouses {
          ...WarehousesFragment
        }
        devices {
            id
            name
            customName
        }
    }
    ${categoryFragment}
    ${taxFragment}
    ${warehousesFragment}
`;

export const ProductFormQuery = gql`
    query ProductFormQuery{
        categories {
            ...CategoriesFragment
            categoryId
            color
        }
        taxes {
            ...TaxesFragment
        }
        devices {
            id
            name
            customName
        }
        warehouses {
          ...WarehousesFragment
        }
    }
    ${categoryFragment}
    ${taxFragment}
    ${warehousesFragment}
`;

export const GET_CATEGORY_OPTIONS = gql`
     query GET_CATEGORY_OPTIONS{
        categories {
            ...CategoriesFragment
        }
    }
    ${categoryFragment}
`;

export const READ_CATEGORY = gql`
  query GetCategory($id: String!){
    category(id: $id) {
      id
      name
    }
  }
`;